import { useContext } from 'react';

import { ProfileContext } from './profile-provider';

export const useProfile = () => useContext(ProfileContext);
